import Swiper from 'swiper';
import SwiperCore, { Autoplay, EffectFade } from 'swiper/core';
import 'swiper/css/effect-fade';
SwiperCore.use([Autoplay, EffectFade]);

export default class PRCarousel {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * product carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.parentContainer = this.sliderElement.parentElement;
        this.carouselLogos = this.parentContainer.querySelectorAll('.js-pr-carousel-logo');
        this.swiper = null;
        this.init()
    }

    init() {
    
        this.swiper = new Swiper(this.sliderElement, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            }
        });

        this.swiper.autoplay.stop();

        document.addEventListener("DOMContentLoaded", () =>{
            this.swiper.on('autoplayStart', () => {
                this.startProgressBar();            
            });
    
            this.swiper.on('slideChange', () => {
                this.resetProgressBar();          
            });
            
            this.swiper.autoplay.start();
            this.handleLogoClicks();
        });
    }

    handleLogoClicks() {
        this.carouselLogos.forEach(element => {
            element.addEventListener("click", () => {
                const slideIndex = element.dataset.slide;
                this.swiper.slideTo(slideIndex, 300, false);
            })
        });
    }
    
    handleCarouselHover

    startProgressBar() {
        if(this.swiper) {
            const activeLogo = this.parentContainer.querySelector(`.js-pr-carousel-logo[data-slide="${this.swiper.activeIndex}"]`);
            const progressBar = activeLogo.querySelector('.js-pr-carousel-progress-bar');
            const delay = this.swiper.params.autoplay.delay;
    
            // Reset progress bar width
            progressBar.style.width = '0%';
            activeLogo.classList.add('is-active');
    
            // Clear any existing intervals
            clearInterval(this.progressBarInterval);
    
            // Animate the progress bar over the duration of the autoplay delay
            let startTime = Date.now();
            this.progressBarInterval = setInterval(() => {
                let elapsed = Date.now() - startTime;
                let progress = (elapsed / delay) * 100;
                progressBar.style.width = `${Math.min(progress, 100)}%`;
    
                // Stop interval when the progress reaches 100%
                if (progress >= 100) {
                    clearInterval(this.progressBarInterval);
                }
            }, 10);
        }
    }

    resetProgressBar() {
        if(this.swiper) {
            const activeLogo = this.parentContainer.querySelector(`.js-pr-carousel-logo.is-active`);

            if(activeLogo) {
                const progressBar = activeLogo.querySelector('.js-pr-carousel-progress-bar');
                activeLogo.classList.remove('is-active');
                progressBar.style.width = '0%';
            }
            clearInterval(this.progressBarInterval);
            this.startProgressBar(this.swiper);
        }
    }
}
